import { QuotationStatusEnum } from 'app/shared/enums';
import { TravelQuotationState } from 'app/store/data/travelQuotation';

export const botTravelQuotation: TravelQuotationState = {
  id: 'e96373ba-ebc3-49ec-ab33-fe5b2fc459a8',
  number: 'Q7FZNXT',
  status: QuotationStatusEnum.Created,
  activeABTests: [],
  travelers: [],
};
